// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Modal Toolbar — canonical modal top-bar control strip.

   The shared search/toolbar chrome for modal surfaces (Concept Vault,
   Pharmacy, and future modals). Originated as ConceptVault's \`.cv-toolbar\`
   / \`.cv-search-*\`; extracted here 2026-05-20 so every modal top bar
   inherits one definition instead of each surface re-implementing it.

   Usage:
     <div class="modal-toolbar">
       <label class="modal-search">
         <svg class="modal-search-icon" .../>
         <input class="modal-search-input" .../>
         <button class="modal-search-clear" .../>   (render only when query non-empty)
       </label>
       ...surface-specific controls (filter chips, sort, actions) layer
          their own classes alongside .modal-toolbar...
     </div>

   Surface-specific controls that sit in the toolbar can read the control
   height via var(--modal-toolbar-control-h), which .modal-toolbar defines.
   ============================================ */

.modal-toolbar {
  --modal-toolbar-control-h: 28px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 4px 4px;
  background: transparent;
  border: 0;
  border-radius: 0;
}

.modal-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 220px;
  min-width: 180px;
  height: var(--modal-toolbar-control-h);
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 0;
  transition: border-color 150ms ease;
}
.modal-search:hover { border-bottom-color: rgba(255, 255, 255, 0.22); }
/* Canonical focus accent: blue (#3b82f6). */
.modal-search:focus-within { border-bottom-color: rgba(59, 130, 246, 0.65); }

.modal-search-icon {
  position: absolute;
  left: 2px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(248, 250, 252, 0.40);
  pointer-events: none;
  transition: color 150ms ease;
}
.modal-search:focus-within .modal-search-icon { color: rgba(59, 130, 246, 0.85); }

.modal-search-input {
  flex: 1 1;
  height: 100%;
  padding: 0 22px 0 22px;
  font-size: 12px;
  font-family: var(--font-primary);
  color: rgba(248, 250, 252, 0.95);
  background: transparent;
  border: 0;
  outline: none;
}
.modal-search-input::placeholder {
  color: rgba(248, 250, 252, 0.32);
  letter-spacing: 0.01em;
}

.modal-search-clear {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: rgba(248, 250, 252, 0.45);
  cursor: pointer;
  transition: color 150ms ease;
}
.modal-search-clear:hover { color: rgba(248, 250, 252, 0.95); }
`, "",{"version":3,"sources":["webpack://./src/styles/modal-toolbar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;iDAqBiD;;AAEjD;EACE,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;EACvB,SAAS;EACT,kDAAkD;EAClD,gBAAgB;EAChB,mCAAmC;AACrC;AACA,sBAAsB,8CAA8C,EAAE;AACtE,4CAA4C;AAC5C,6BAA6B,6CAA6C,EAAE;;AAE5E;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,4BAA4B;AAC9B;AACA,gDAAgD,+BAA+B,EAAE;;AAEjF;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gCAAgC;EAChC,gCAAgC;EAChC,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,4BAA4B;AAC9B;AACA,4BAA4B,gCAAgC,EAAE","sourcesContent":["/* ============================================\n   Modal Toolbar — canonical modal top-bar control strip.\n\n   The shared search/toolbar chrome for modal surfaces (Concept Vault,\n   Pharmacy, and future modals). Originated as ConceptVault's `.cv-toolbar`\n   / `.cv-search-*`; extracted here 2026-05-20 so every modal top bar\n   inherits one definition instead of each surface re-implementing it.\n\n   Usage:\n     <div class=\"modal-toolbar\">\n       <label class=\"modal-search\">\n         <svg class=\"modal-search-icon\" .../>\n         <input class=\"modal-search-input\" .../>\n         <button class=\"modal-search-clear\" .../>   (render only when query non-empty)\n       </label>\n       ...surface-specific controls (filter chips, sort, actions) layer\n          their own classes alongside .modal-toolbar...\n     </div>\n\n   Surface-specific controls that sit in the toolbar can read the control\n   height via var(--modal-toolbar-control-h), which .modal-toolbar defines.\n   ============================================ */\n\n.modal-toolbar {\n  --modal-toolbar-control-h: 28px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 4px 4px;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n}\n\n.modal-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 220px;\n  min-width: 180px;\n  height: var(--modal-toolbar-control-h);\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 0;\n  transition: border-color 150ms ease;\n}\n.modal-search:hover { border-bottom-color: rgba(255, 255, 255, 0.22); }\n/* Canonical focus accent: blue (#3b82f6). */\n.modal-search:focus-within { border-bottom-color: rgba(59, 130, 246, 0.65); }\n\n.modal-search-icon {\n  position: absolute;\n  left: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: rgba(248, 250, 252, 0.40);\n  pointer-events: none;\n  transition: color 150ms ease;\n}\n.modal-search:focus-within .modal-search-icon { color: rgba(59, 130, 246, 0.85); }\n\n.modal-search-input {\n  flex: 1;\n  height: 100%;\n  padding: 0 22px 0 22px;\n  font-size: 12px;\n  font-family: var(--font-primary);\n  color: rgba(248, 250, 252, 0.95);\n  background: transparent;\n  border: 0;\n  outline: none;\n}\n.modal-search-input::placeholder {\n  color: rgba(248, 250, 252, 0.32);\n  letter-spacing: 0.01em;\n}\n\n.modal-search-clear {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: rgba(248, 250, 252, 0.45);\n  cursor: pointer;\n  transition: color 150ms ease;\n}\n.modal-search-clear:hover { color: rgba(248, 250, 252, 0.95); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
